import { ProdutoService } from 'app/shared/services/produto.service';
import { ChangeDetectionStrategy, HostListener, Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Produto } from 'app/shared/interfaces/produto';
import { AppConfirmService } from 'app/shared/services/app-confirm/app-confirm.service';
import { LayoutService } from 'app/shared/services/layout.service';
import { BehaviorSubject } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-produto-codbar-popup',
  templateUrl: './produto-codbar-popup.component.html',
  styleUrls: ['./produto-codbar-popup.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush // Adicionado para otimização
})
export class ProdutoCodbarPopupComponent implements OnInit {
  public produtoForm: FormGroup;
  produto: Produto;
  layoutConf: any;

  maskCodigoBarra = {
    mask: '0000000000000{*}',
    lazy: true,
    placeholderChar: '_'
  };

  @HostListener('window:keyup.esc') onKeyUp() {
    this.confirmService.confirm({ message: `Deseja realmente fechar? Poderá haver perda de dados.` })
      .subscribe(res => {
        if (res) {
          this.dialogRef.close();
        }
      });
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ProdutoCodbarPopupComponent>,
    private fb: FormBuilder,
    private confirmService: AppConfirmService,
    private layout: LayoutService,
    private produtoService: ProdutoService,
    private snack: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.layoutConf = this.layout.layoutConf;
    this.produto = this.data.payload;
    this.buildProdutoForm(this.produto);
    console.log(`Produto: ${this.produto.codigo} - ${this.produto.descricao}`);
  }

  buildProdutoForm(produto: Produto) {
    this.produtoForm = this.fb.group({
      id: [produto.id],
      descricao: [produto.descricao],
      codigobarra1: [produto?.codigobarra1 || ''],
      codigobarra2: [produto?.codigobarra2 || ''],
      codigobarra3: [produto?.codigobarra3 || ''],
      codigobarra4: [produto?.codigobarra4 || '']
    });
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        console.log(`${field} - ${control.valid}`);
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  save() {
    if (this.produtoForm.invalid) {
      this.validateAllFormFields(this.produtoForm);
      this.snack.open('Por favor, corrija os erros nos campos!', 'OK', { duration: 5500 });
      return;
    }

    const result = new BehaviorSubject<Produto>(null);
    this.produtoService.saveOrUpdate(this.produtoForm.value).subscribe(
      val => {
        this.snack.open('SALVO COM SUCESSO!', 'OK', { duration: 5500 });
        this.confirmService.confirm({
          title: 'SALVAR',
          message: 'OK, Produto Salvo com Sucesso!',
          error: false
        });
        result.next(val);
        this.dialogRef.close(val); // Fecha o dialog com o resultado
      },
      err => {
        this.snack.open(`ERRO: ${err.error?.status || 'Erro desconhecido'}!`, 'ERRO', { duration: 5500 });
        this.confirmService.confirm({
          title: 'ERRO AO SALVAR',
          message: err.error?.status || 'Erro desconhecido',
          error: true
        });
        result.error(err);
      }
    );
    return result;
  }

  close() {
    this.dialogRef.close();
  }
}